/**
 * @voltxampere/ui — TL082 lower-supply JFET-input op-amp variant (Sprint 39-3)
 *
 * TL072 sibling with a narrower supply-rail spec. Engine params
 * mirror TL072 because the engine has no notion of supply rails;
 * the supply difference would surface in a future Inspector card
 * when the supply layer lands.
 *
 * Reference: TI SLOS080F.
 *
 * Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampTl082 = {
    id: "tl082",
    nameTr: "TL082 (FET-Girişli, Düşük Voltaj, DIP-8)",
    nameEn: "TL082 (FET-Input, Low-Supply, DIP-8)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "TL082",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 2e5,
        saturationVoltage: 13,
        gainBandwidthProduct: 3e6,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-tl082.js.map